import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Chip from 'material-ui/Chip';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from 'material-ui/Dialog';
import PropTypes from 'prop-types';

import {
  localDateFormat,
  localDateFormatDays,
  localTimeFormatWithSecond
} from '../../helper/dateFormat';
import NavDateRangeSelector from './NavDateRangeSelector';
import NavSamplesQuickViews from './NavSamplesQuickViews';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import { NAV_RANGE_DIALOG_TITLE } from '../../constants/actionMessages';

const styles = {
  alignTop: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  currentlySelected: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  selectedView: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  selectedViewItem: {
    justifyContent: 'center',
    display: 'flex',
    height: '1rem'
  },
  selectedViewItemFrom: {
    marginRight: '1rem',
    flex: 1
  },
  selectedViewItemTo: {
    marginLeft: '1rem',
    flex: 1
  },
  currentlySelectedDate: {
    marginRight: '0.3rem'
  },
  spacer: {
    marginRight: '0.7rem',
    marginLeft: '0.7rem'
  }
};

const rangeSelectorButton = ({
  loading,
  timezone,
  onClickHandler,
  classes,
  from,
  to
}) => (
  <Button disabled={loading} raised color="primary" onClick={onClickHandler}>
    <span className={classes.currentlySelectedDate}>
      {localDateFormatDays({ timezone }).format(from * 1000)}
    </span>{' '}
    {localTimeFormatWithSecond({ timezone }).format(from * 1000)}
    <span className={classes.spacer}>&mdash;</span>
    <span className={classes.currentlySelectedDate}>
      {localDateFormatDays({ timezone }).format(to * 1000)}
    </span>{' '}
    {localTimeFormatWithSecond({ timezone }).format(to * 1000)}
  </Button>
);

rangeSelectorButton.propTypes = {
  loading: PropTypes.bool,
  timezone: PropTypes.string,
  onClickHandler: PropTypes.func,
  classes: PropTypes.object,
  from: PropTypes.number,
  to: PropTypes.number
};

class NavDateRangeDialog extends Component {
  state = {
    open: false,
    from: null,
    to: null,
    aggregationLevel: null,
    aggregationLevelSeconds: null
  };

  handleRequestClose = (event, updateParams) => {
    if (updateParams) {
      const { from, to, aggregationLevel } = this.state;

      const fromToChanged =
        from !== this.props.queryParams.from ||
        to !== this.props.queryParams.to;

      const aggregationLevelChanged =
        aggregationLevel !== this.props.aggregationLevel;

      if (aggregationLevelChanged && !fromToChanged) {
        this.props.updateQueryAggregationLevel({ aggregationLevel });
      } else {
        this.props.updateQueryParams({ from, to, aggregationLevel });
      }
      this.setState({ open: false });
      return;
    }

    this.setState({
      open: false,
      from: this.props.queryParams.from,
      to: this.props.queryParams.to,
      aggregationLevel: this.props.queryParams.aggregationLevel,
      aggregationLevelSeconds: this.props.queryParams.aggregationLevelSeconds
    });
  };

  setLocalQueryParams = update => this.setState({ ...update });

  componentWillMount() {
    const {
      queryParams: { from, to, aggregationLevel, aggregationLevelSeconds }
    } = this.props;
    this.setState({ from, to, aggregationLevel, aggregationLevelSeconds });
  }

  componentWillReceiveProps(nextProps) {
    const {
      queryParams: { from, to, aggregationLevel, aggregationLevelSeconds }
    } = nextProps;
    this.setState({ from, to, aggregationLevel, aggregationLevelSeconds });
  }

  render() {
    const { timezone, loading, classes, pageType } = this.props;
    const { from, to, aggregationLevel, aggregationLevelSeconds } = this.state;
    const localQueryParams = {
      from,
      to,
      aggregationLevel,
      aggregationLevelSeconds
    };
    const fromAndToValid = from && to;

    return (
      <div>
        {rangeSelectorButton({
          loading,
          timezone,
          onClickHandler: () => this.setState({ open: true }),
          classes,
          from,
          to
        })}

        <Dialog
          maxWidth={'md'}
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
        >
          <DialogTitle>{NAV_RANGE_DIALOG_TITLE}</DialogTitle>
          <DialogContent>
            <div className={classes.alignTop}>
              <div>
                <NavSamplesQuickViews
                  updateQueryParams={this.setLocalQueryParams}
                  loading={loading}
                  timezone={timezone}
                  pageType={pageType}
                />
              </div>
              <div>
                <NavDateRangeSelector
                  queryParams={localQueryParams}
                  updateQueryParams={this.setLocalQueryParams}
                  timezone={timezone}
                />

                <div className={classes.selectedView}>
                  <div
                    className={classNames(
                      classes.selectedViewItem,
                      classes.selectedViewItemFrom
                    )}
                  >
                    {from ? (
                      <Chip
                        className={classes.selectedViewDateTime}
                        label={localDateFormat({ timezone }).format(
                          from * 1000
                        )}
                      />
                    ) : null}
                  </div>
                  <div
                    className={classNames(
                      classes.selectedViewItem,
                      classes.selectedViewItemTo
                    )}
                  >
                    {to ? (
                      <Chip
                        className={classes.selectedViewDateTime}
                        label={localDateFormat({ timezone }).format(to * 1000)}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleRequestClose(undefined, false)}
              color="primary"
            >
              Dismiss
            </Button>
            <Button
              raised
              onClick={() => this.handleRequestClose(undefined, true)}
              disabled={!fromAndToValid}
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

NavDateRangeDialog.propTypes = {
  queryParam: PropTypes.object,
  updateQueryParams: PropTypes.func,
  updateQueryAggregationLevel: PropTypes.func,
  timezone: PropTypes.string,
  pageType: PropTypes.string,
  loading: PropTypes.bool
};

export default withStyles(styles, { name: 'NavDateRangeDialog' })(
  NavDateRangeDialog
);

/*

<div className={classes.currentlySelected}>
{pageType === 'chart'
  ? <select value={aggregationLevel}
            onChange={(event) => this.setLocalQueryParams({aggregationLevel: event.target.value === "false" ? false : event.target.value})}>
    <option value="days_1">Day</option>
    <option value="hours_1">Hour</option>
    <option value="minutes_15">15 Minutes</option>
    <option value="minutes_1">Minute</option>
    <option value="none">none</option>
    <option value={false}>Automatically</option>
  </select>
  : null
}
</div>
 */



// WEBPACK FOOTER //
// ./src/components/nav/NavDateRangeDialog.js